export function isValidPostcode(postcode: string): boolean {
  const regex = /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/;
  return regex.test(postcode.trim());
}

export function extractPostcode(address: string): string {
    const postcodeRegex = /\b[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}\b/;
    const match = address.match(postcodeRegex);
    return match ? match[0] : '';
 }

